var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReaward({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.12094 3.06801C10.7964 1.644 13.2036 1.644 14.8791 3.06801L15.0342 3.08036C17.1177 3.24617 18.7773 4.96162 18.9507 7.12867C20.3498 8.76602 20.3498 11.234 18.9507 12.8713C18.8373 14.2889 18.0879 15.5131 17 16.2369V21C17 21.5523 16.5523 22 16 22H15.5C15 22 12 21 12 21C10.8817 21.3728 9 22 8.5 22H8C7.44772 22 7 21.5523 7 21V16.2369C5.91208 15.5131 5.16275 14.2889 5.04932 12.8713C3.65023 11.234 3.65023 8.76602 5.04932 7.12867C5.22272 4.96162 6.88229 3.24617 8.96577 3.08036L9.12094 3.06801ZM18 10C18 13.3137 15.3137 16 12 16C8.68629 16 6 13.3137 6 10C6 6.68629 8.68629 4 12 4C15.3137 4 18 6.68629 18 10Z",
    fill: "#72F238"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 10C16 12.2091 14.2091 14 12 14C9.79086 14 8 12.2091 8 10C8 7.79086 9.79086 6 12 6C14.2091 6 16 7.79086 16 10Z",
    fill: "#72F238"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReaward);
export default __webpack_public_path__ + "static/media/reaward.249e0b07f5d7f6d0397f107603d537c3.svg";
export { ForwardRef as ReactComponent };